const Si = {
  cells: {
    hct: {
      neonate: {
        snug: 0.18, // need blood transfusion
        lo: 0.47,
        hi: 0.67,
        crical: 0.7, // Panic Value
        alert: 0.75,
        unit: null,
      },
      infant: {
        snug: 0.18,
        lo: 0.37,
        hi: 0.41,
        crical: 0.5,
        alert: 0.55,
        unit: null,
      },
      child: {
        snug: 0.18,
        lo: 0.32,
        hi: 0.42,
        crical: 0.5,
        alert: 0.55,
        unit: null,
      },
      adult: {
        Male: {
          snug: 0.18,
          lo: 0.4,
          hi: 0.54,
          warn: 0.6,
          alert: 0.65,
          crical: 0.7,
          unit: null,
        },
        Female: {
          snug: 0.18,
          lo: 0.36,
          hi: 0.47,
          warn: 0.5,
          alert: 0.55,
          crical: 0.6,
          unit: null,
        },
      },
    },
    hgb: {
      neonate: {
        snug: 60,
        lo: 170,
        hi: 220,
        warn: 240,
        alert: 260,
        crical: 280,
        unit: "g/L",
      },
      infant: {
        snug: 60,
        lo: 110,
        hi: 125,
        warn: 160,
        alert: 180,
        crical: 200,
        unit: "g/L",
      },
      child: {
        snug: 60,
        lo: 120,
        hi: 140,
        warn: 170,
        alert: 180,
        crical: 200,
        unit: "g/L",
      },
      adult: {
        Male: {
          snug: 60,
          lo: 130,
          hi: 180,
          warn: 200,
          alert: 210,
          crical: 220,
          unit: "g/L",
        },
        Female: {
          snug: 60,
          lo: 115,
          hi: 165,
          warn: 180,
          alert: 190,
          crical: 200,
          unit: "g/L",
        },
      },
    },
    rbc: {
      neonate: {
        snug: 1.98,
        lo: 4.7,
        hi: 6.1,
        warn: 6.6,
        alert: 7.0,
        crical: 7.5,
        unit: "x10<sup>12</sup>/L",
      },
      infant: {
        snug: 1.98,
        lo: 3.95,
        hi: 4.75,
        warn: 5.5,
        alert: 6.0,
        crical: 6.5,
        unit: "x10<sup>12</sup>/L",
      },
      child: {
        snug: 1.98,
        lo: 4.5,
        hi: 5.5,
        warn: 6.0,
        alert: 6.5,
        crical: 7.0,
        unit: "x10<sup>12</sup>/L",
      },
      adult: {
        Male: {
          snug: 1.98,
          lo: 4.6,
          hi: 6.2,
          warn: 6.6,
          alert: 7.0,
          crical: 7.5,
          unit: "x10<sup>12</sup>/L",
        },
        Female: {
          snug: 1.98,
          lo: 4.2,
          hi: 5.4,
          warn: 6.0,
          alert: 6.5,
          crical: 6.8,
          unit: "x10<sup>12</sup>/L",
        },
      },
    },
    wbc: {
      neonate: {
        snug: 1,
        lo: 10,
        hi: 30,
        warn: 35,
        alert: 40,
        crical: 45,
        unit: "x10<sup>9</sup>/L",
      },
      infant: {
        snug: 1,
        lo: 6,
        hi: 20,
        warn: 25,
        alert: 30,
        crical: 35,
        unit: "x10<sup>9</sup>/L",
      },
      child: {
        snug: 1,
        lo: 5,
        hi: 15,
        warn: 18,
        alert: 20,
        crical: 25,
        unit: "x10<sup>9</sup>/L",
      },
      adult: {
        Male: {
          snug: 1,
          lo: 4,
          hi: 10,
          warn: 15,
          alert: 18,
          crical: 20,
          unit: "x10<sup>9</sup>/L",
        },
        Female: {
          snug: 1,
          lo: 4,
          hi: 10,
          warn: 15,
          alert: 18,
          crical: 25,
          unit: "x10<sup>9</sup>/L",
        },
      },
    },
  },
  plt: {
    snug: 100,
    lo: 150,
    hi: 450,
    warn: 600,
    alert: 800,
    crical: 1000,
    unit: "x10<sup>9</sup>/L",
  },

  differentials: {
    Segmenters: {
      neonate: {
        snug: 0,
        lo: 0.0,
        hi: 0.25,
        warn: 0.7,
        alert: 0.75,
        crical: 0.8,
      },
      infant: {
        snug: 0,
        lo: 0.0,
        hi: 0.22,
        warn: 0.6,
        alert: 0.65,
        crical: 0.7,
      },
      child: {
        snug: 0,
        lo: 0.31,
        hi: 0.61,
        warn: 0.7,
        alert: 0.75,
        crical: 0.8,
      },
      adult: {
        snug: 0.2,
        lo: 0.36,
        hi: 0.66,
        warn: 0.7,
        alert: 0.75,
        crical: 0.8,
      },
    },
    Lymphocytes: {
      neonate: {
        snug: 0,
        lo: 0.0,
        hi: 0.57,
        warn: 0.7,
        alert: 0.8,
        crical: 0.85,
      },
      infant: {
        snug: 0,
        lo: 0.0,
        hi: 0.63,
        warn: 0.7,
        alert: 0.8,
        crical: 0.85,
      },
      child: {
        snug: 0,
        lo: 0.28,
        hi: 0.38,
        warn: 0.45,
        alert: 0.5,
        crical: 0.55,
      },
      adult: {
        snug: 0,
        lo: 0.24,
        hi: 0.44,
        warn: 0.5,
        alert: 0.55,
        crical: 0.6,
      },
    },
    Monocytes: {
      neonate: {
        snug: 0,
        lo: 0.0,
        hi: 0.07,
        warn: 0.1,
        alert: 0.15,
        crical: 0.2,
      },
      infant: {
        snug: 0,
        lo: 0.0,
        hi: 0.05,
        warn: 0.08,
        alert: 0.1,
        crical: 0.15,
      },
      child: {
        snug: 0,
        lo: 0.0,
        hi: 0.05,
        warn: 0.08,
        alert: 0.1,
        crical: 0.15,
      },
      adult: {
        snug: 0,
        lo: 0.0,
        hi: 0.04,
        warn: 0.08,
        alert: 0.1,
        crical: 0.15,
      },
    },
    Eosinophils: {
      neonate: {
        snug: 0,
        lo: 0.0,
        hi: 0.03,
        warn: 0.05,
        alert: 0.1,
        crical: 0.2,
      },
      infant: {
        snug: 0,
        lo: 0.0,
        hi: 0.03,
        warn: 0.05,
        alert: 0.1,
        crical: 0.2,
      },
      child: {
        snug: 0,
        lo: 0.0,
        hi: 0.03,
        warn: 0.05,
        alert: 0.1,
        crical: 0.2,
      },
      adult: {
        snug: 0,
        lo: 0.0,
        hi: 0.03,
        warn: 0.05,
        alert: 0.1,
        crical: 0.2,
      },
    },
    Stabs: {
      neonate: {
        snug: 0,
        lo: 0.0,
        hi: 0.08,
        warn: 0.1,
        alert: 0.15,
        crical: 0.2,
      },
      infant: {
        snug: 0,
        lo: 0.0,
        hi: 0.08,
        warn: 0.1,
        alert: 0.15,
        crical: 0.2,
      },
      child: {
        snug: 0,
        lo: 0.05,
        hi: 0.11,
        warn: 0.15,
        alert: 0.2,
        crical: 0.25,
      },
      adult: {
        snug: 0,
        lo: 0.05,
        hi: 0.11,
        warn: 0.15,
        alert: 0.2,
        crical: 0.25,
      },
    },
    Basophils: {
      neonate: {
        snug: 0,
        lo: 0.0,
        hi: 0.01,
        warn: 0.015,
        alert: 0.02,
        crical: 0.03,
      },
      infant: {
        snug: 0,
        lo: 0.0,
        hi: 0.01,
        warn: 0.015,
        alert: 0.02,
        crical: 0.03,
      },
      child: {
        snug: 0,
        lo: 0.0,
        hi: 0.01,
        warn: 0.015,
        alert: 0.02,
        crical: 0.03,
      },
      adult: {
        snug: 0,
        lo: 0.0,
        hi: 0.01,
        warn: 0.015,
        alert: 0.02,
        crical: 0.03,
      },
    },
  },
  rci: {
    MCV: {
      neonate: { snug: 0, lo: 108, hi: 136, crical: 150, unit: "fL" },
      infant: { snug: 0, lo: 82, hi: 98, crical: 105, unit: "fL" },
      child: { snug: 0, lo: 75, hi: 87, crical: 100, unit: "fL" },
      adult: { snug: 0, lo: 85, hi: 95, crical: 105, unit: "fL" },
    },
    MCH: {
      neonate: { snug: 0, lo: 29, hi: 35, crical: 45, unit: "fmol" },
      infant: { snug: 0, lo: 24, hi: 30, crical: 35, unit: "fmol" },
      child: { snug: 0, lo: 25, hi: 31, crical: 36, unit: "fmol" },
      adult: { snug: 0, lo: 28, hi: 32, crical: 37, unit: "fmol" },
    },
    MCHC: {
      neonate: { snug: 0, lo: 280, hi: 320, critical: 450, unit: "g/L" },
      infant: { snug: 0, lo: 290, hi: 310, critical: 440, unit: "g/L" },
      child: { snug: 0, lo: 330, hi: 350, critical: 400, unit: "g/L" },
      adult: { snug: 0, lo: 320, hi: 360, critical: 460, unit: "g/L" },
    },
    RDWc: {
      neonate: { snug: 0, lo: 11.5, hi: 14.5, crical: 16.5, unit: "%" },
      infant: { snug: 0, lo: 11.5, hi: 14.5, crical: 16.5, unit: "%" },
      child: { snug: 0, lo: 11.5, hi: 14.5, crical: 16.5, unit: "%" },
      adult: { snug: 0, lo: 11.5, hi: 14.5, crical: 16.5, unit: "%" },
    },
  },
};

export default Si;
